module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAdCAMAAACOj/wDAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABRUExURUdwTDJm/ytf/67J/zNl/zJl/y5h/zFk/zJl/zBg/zFl/5it/zBj/zJl/63J/zJl/67J/67J/67I/67G/zJl/zFk/zJk/6zI/67L/zNm/67J/6aRq2sAAAAZdFJOUwCPFr+/9Culnx9dCT/l2dF7QiwYtXSFilgGl71JAAAArElEQVQoz53R7Q6DIAwF0PpRUERR1G3y/g+6VcwcrF3M7g9NOIBthWWTggY2OfqFRctFuR0VsCneOA8jLVQVPafBJziFgZZD6GhLGK+jD9WJ9/BIEOa9iC6+/FmQ5avVO2LNxcUh/JzQRVyttVpATXUgjz1ZLVxL/Rrhmw0dXJDF/ui9tbdvRG3KOELHt+JWgLKXhqA+LUOEEsUJmcRSxNTya//+K1kaMI0Y9QREQjTv+oZ41QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MallPage/power.png
// module id = 4XNJ
// module chunks = 0